<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols=3 v-for="(image, index) in images" :key=index>
          <!-- 画像表示 -->
          <v-card
            class="mx-auto"
            max-width="300"
            elevation="10"
            @click.stop="showPhotoSwipe(index)"
          >
            <v-img
              class="white--text align-end"
              :src="image"
            >
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-photo-swipe
      :isOpen="isOpen"
      :items="images"
      :options="photoswipeOptions"
      @close="hidePhotoSwipe" />
  </div>
</template>

<script>
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'

export default {
  components: {
    VPhotoSwipe,
  },

  props: {
    previewImages: {
      type: Array,
      required: true,
    }
  },

  data: () => ({
    photoswipeOptions: {
      index: 0,
      closeOnScroll: false
    },
    isOpen: false,
  }),

  computed: {
    images() {
      return this.previewImages.map(image => {
        return {
          src: image,
          w: 600,
          h: 900
        }
      })
    }
  },

  methods: {
    showPhotoSwipe(index) {
      this.isOpen = true
      this.$set(this.photoswipeOptions, 'index', index)
    },
    hidePhotoSwipe(){
      this.isOpen = false
    },
  }
}
</script>
